import React from 'react'
import SplashScreen from '../components/common/SplashScreen'

const SplashScreenRunner = () => {
  return (
    <div>
      <SplashScreen navigateTo="/home" duration={3000} />
    </div>
  )
}

export default SplashScreenRunner